// extracted by mini-css-extract-plugin
module.exports = {"main":"View_main__15qAe","header_div":"View_header_div__2ikzJ","data_div":"View_data_div__Uk5UG"};